/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_IncomingInputs */

const en_wb_support_incoming = /** @type {(inputs: Wb_Support_IncomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi! Do you have availability on Saturday, and what does a consultation cost?`)
};

const lv_wb_support_incoming = /** @type {(inputs: Wb_Support_IncomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sveiki! Vai sestdienā ir brīvi laiki un cik maksā konsultācija?`)
};

/**
* | output |
* | --- |
* | "Hi! Do you have availability on Saturday, and what does a consultation cost?" |
*
* @param {Wb_Support_IncomingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_incoming = /** @type {((inputs?: Wb_Support_IncomingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_IncomingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_incoming(inputs)
	return en_wb_support_incoming(inputs)
});